import { apolloClient } from '@/vue-apollo'
import SaveGitHubToken from '@/graphql/mutations/SaveGitHubToken'
import RemoveGitHubToken from '@/graphql/mutations/RemoveGitHubToken'
import ListGitHubRepos from '@/graphql/queries/ListGitHubRepos'
import CreateGitHubRepo from '@/graphql/mutations/CreateGitHubRepo'
import InitGitHubRepo from '@/graphql/mutations/InitGitHubRepo'
import ListGitHubRepoFiles from '@/graphql/queries/ListGitHubRepoFiles'
import ListGitHubRepoBranches from '@/graphql/queries/ListGitHubRepoBranches'
import FetchGitHubRepoFileContent from '@/graphql/queries/FetchGitHubRepoFileContent'
import CommitGitHubRepoFiles from '@/graphql/mutations/CommitGitHubRepoFiles'
import DeleteGitHubRepo from '@/graphql/mutations/DeleteGitHubRepo'

export const github = {
  namespaced: true,
  state: {
    githubAccounts: []
  },
  mutations: {
    setGithubAccounts (state, payload) {
      state.githubAccounts = payload || []
    }
  },
  actions: {
    async saveGitHubToken ({ commit }, { code }) {
      const res = await apolloClient.mutate({
        mutation: SaveGitHubToken,
        variables: {
          code
        },
        fetchPolicy: 'no-cache'
      })
      const result = res.data.saveGitHubToken

      if (result?.success && result?.resData?.githubAccounts) {
        commit('setGithubAccounts', result.resData.githubAccounts || [])
      }

      return result
    },
    async removeGitHubToken ({ commit }, { username }) {
      const res = await apolloClient.mutate({
        mutation: RemoveGitHubToken,
        variables: {
          username
        },
        fetchPolicy: 'no-cache'
      })
      const result = res.data.removeGitHubToken

      if (result?.success && result?.resData?.githubAccounts) {
        commit('setGithubAccounts', result.resData.githubAccounts || [])
      }

      return result
    },
    async listGitHubRepos ({ commit }, { login }) {
      const res = await apolloClient.query({
        query: ListGitHubRepos,
        variables: {
          login
        },
        fetchPolicy: 'no-cache'
      })
      return res.data.listGitHubRepos
    },
    async listGitHubRepoBranches ({ commit }, { login, owner, repo }) {
      const res = await apolloClient.query({
        query: ListGitHubRepoBranches,
        variables: { login, owner, repo },
        fetchPolicy: 'no-cache'
      })
      return res.data.listGitHubRepoBranches
    },
    async createGitHubRepo ({ commit }, { login, repo, description, isPrivate }) {
      const res = await apolloClient.mutate({
        mutation: CreateGitHubRepo,
        variables: { login, repo, description, isPrivate },
        fetchPolicy: 'no-cache'
      })
      return res.data.createGitHubRepo
    },
    async initGitHubRepo ({ commit }, { login, owner, repo, branch, filePath, content, message }) {
      const res = await apolloClient.mutate({
        mutation: InitGitHubRepo,
        variables: { login, owner, repo, branch, filePath, content, message },
        fetchPolicy: 'no-cache'
      })
      return res.data.initGitHubRepo
    },
    async listGitHubRepoFiles ({ commit }, { login, owner, repo, folder, branch }) {
      const res = await apolloClient.query({
        query: ListGitHubRepoFiles,
        variables: { login, owner, repo, folder, branch },
        fetchPolicy: 'no-cache'
      })
      return res.data.listGitHubRepoFiles
    },
    async fetchGitHubRepoFileContent ({ commit }, { login, owner, repo, files, branch }) {
      const res = await apolloClient.query({
        query: FetchGitHubRepoFileContent,
        variables: { login, owner, repo, files, branch },
        fetchPolicy: 'no-cache'
      })
      return res.data.fetchGitHubRepoFileContent
    },
    async commitGitHubRepoFiles ({ commit }, { login, owner, repo, branch, files, message }) {
      const res = await apolloClient.mutate({
        mutation: CommitGitHubRepoFiles,
        variables: { login, owner, repo, branch, files, message },
        fetchPolicy: 'no-cache'
      })
      return res.data.commitGitHubRepoFiles
    },
    async deleteGitHubRepo ({ commit }, { login, owner, repo }) {
      const res = await apolloClient.mutate({
        mutation: DeleteGitHubRepo,
        variables: { login, owner, repo },
        fetchPolicy: 'no-cache'
      })
      return res.data.deleteGitHubRepo
    }
  }
}
